const ATTENDANCE_ROUTE_NAMES = new Set([
  'home',
  'inbox_dashboard',
  'inbox_view',
  'search',
]);

const ATTENDANCE_ROUTE_PATTERNS = [/conversation/i, /^contact/i];

const REPORTING_ROUTE_PATTERN = /report/i;

export const isAttendanceRoute = route => {
  const name = route?.name;
  if (typeof name !== 'string' || name === '') return false;
  if (ATTENDANCE_ROUTE_NAMES.has(name)) return true;
  if (REPORTING_ROUTE_PATTERN.test(name)) return false;
  return ATTENDANCE_ROUTE_PATTERNS.some(pattern => pattern.test(name));
};
